/**
 * @generated SignedSource<<8d51e8252f641f97c0e7762cf9006a38>>
 * @relayHash 98793d1db6774f5134ec9ffe79b26a38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccc1cd5af6e28d8dd9e306f5ad3c0f894264df004843d1ca02e982fce3337a90

import type { ConcreteRequest, Query } from 'relay-runtime';
export type operationNameQuery$variables = {
  projectAri: string;
  updatedFrom?: AGG$DateTime | null | undefined;
};
export type operationNameQuery$data = {
  readonly devOps: {
    readonly ariGraph: {
      readonly deploymentRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type operationNameQuery = {
  response: operationNameQuery$data;
  variables: operationNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updatedFrom"
  }
],
v1 = {
  "concreteType": "DevOps",
  "kind": "LinkedField",
  "name": "devOps",
  "plural": false,
  "selections": [
    {
      "concreteType": "AriGraph",
      "kind": "LinkedField",
      "name": "ariGraph",
      "plural": false,
      "selections": [
        {
          "alias": "deploymentRelationships",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "from",
                  "variableName": "projectAri"
                },
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "project-associated-deployment"
                },
                {
                  "kind": "Variable",
                  "name": "updatedFrom",
                  "variableName": "updatedFrom"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            }
          ],
          "concreteType": "AriGraphRelationshipConnection",
          "kind": "LinkedField",
          "name": "relationships",
          "plural": false,
          "selections": [
            {
              "concreteType": "AriGraphRelationship",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "operationNameQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "devOps"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "operationNameQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "ccc1cd5af6e28d8dd9e306f5ad3c0f894264df004843d1ca02e982fce3337a90",
    "metadata": {},
    "name": "operationNameQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a27df80d74527486e8c233999d88b885";

export default node;
